// Light/dark switch (mid-x58o). <html data-theme="light|dark"> drives brand_zonamento.css.
// public/index.html runs the same rule inline before first paint; test_x58o checks they agree.
// The preference lives on the profile (users.theme_preference) and is cached here for that script.
import { authAPI } from './api';
import BRAND_HEAD from './brandHead.json';

const THEME_CACHE_KEY = 'mid_theme';
const THEME_PREFERENCES = ['light', 'dark', 'system'];
// Agent, admin and credit-intermediary screens keep today's look in both OS modes (mid-9omx).
const THEME_PINNED_LIGHT = /^\/(agent|admin|intermediar|register-credit-intermediary|complete-credit-intermediary|precos-agentes|demo)/;
const osDarkQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

/** The cached preference: 'light' | 'dark' | 'system' (default). */
export function getThemePreference() {
  try {
    const value = localStorage.getItem(THEME_CACHE_KEY);
    return THEME_PREFERENCES.includes(value) ? value : 'system';
  } catch {
    return 'system';
  }
}

/** Caches pref and sets <html data-theme> and theme-color for it on the current route. Returns 'light' | 'dark'. */
export function applyTheme(pref = getThemePreference()) {
  if (!THEME_PREFERENCES.includes(pref)) pref = 'system';
  try {
    localStorage.setItem(THEME_CACHE_KEY, pref);
  } catch {
    /* storage blocked: the OS preference still applies on the next load */
  }
  const dark = !THEME_PINNED_LIGHT.test(window.location.pathname)
    && (pref === 'dark' || (pref === 'system' && !!osDarkQuery?.matches));
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? BRAND_HEAD.themeColorNight : BRAND_HEAD.themeColor);
  return dark ? 'dark' : 'light';
}

/** Applies value now and saves it to the profile (PUT /auth/theme). */
export function setThemePreference(value) {
  applyTheme(value);
  return authAPI.updateThemePreference(value);
}

osDarkQuery?.addEventListener?.('change', () => applyTheme());
